module.exports = __webpack_public_path__ + "static/media/test_cc.d0a09d3e.png";